<template>
  <div class="content">
    <el-form :model="ruleForm" ref="ruleForm" label-width="100px" class="demo-ruleForm">
      <el-form-item label="选择公众号平台：" prop="iccids" label-width="151px">
      <el-select v-model="ruleForm.channel" filterable clearable placeholder="请选择公众号平台" style="width:420px">
        <el-option v-for="item in platformData" :key="item.appId" :label="item.name" :value="item.appId"></el-option>
      </el-select>
      </el-form-item>
      <el-form-item label="ICCID列表：" prop="iccids" label-width="151px">
        <el-input
          v-model="ruleForm.iccids"
          type="textarea"
          :placeholder="'以回车键分割ICCID\n最多200条数据'"
          rows="6"
          style="width:420px"
        ></el-input>
      </el-form-item>
      <el-form-item label="ICCID范围：" prop="startIccid" label-width="151px">
        <el-input
          v-model="ruleForm.startIccid"
          style="width: 200px;margin-right: 10px;"
          placeholder="包含开始值"
        ></el-input>
        <span>-</span>
        <el-input
          v-model="ruleForm.endIccid"
          style="width: 200px;margin-left: 10px;"
          placeholder="包含终止值"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" size="medium" @click="note()" >提交</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { qrCardExport } from "@/api/api.js";
import { wechatPage } from "@/api/api.js";
export default {
  name:"codeQR",
  data() {
    return {
      ruleForm: {
      },
      submitLoading:false,
      platformData:[]
    };
  },
  watch:{
    $route: {
      handler(){
        this.$set(this.ruleForm,"iccids",this.$route.params.iccids);
      },
      immediate:true
    }
  },
  computed: {
  },
  methods: {
    note() {
      let { iccids } = this.ruleForm;
      let data = {
        ...this.ruleForm,
        iccids:iccids ? iccids.split("\n") : []
      };
      qrCardExport(data).then(res => {
          this.$notify.info({
            title: "提示",
            message: "已提交二维码任务，请在任务中心查看进度",
            duration: 1000,
            offset:30
          });
          setTimeout(()=>{
            this.ruleForm ={};
            this.$router.push({ path: `/taskCenter/missionList`});
          },1000)
      });
    },
    initPlatform(){
      let params= {
        page: 1,
        pageSize: 100,
      }
      wechatPage(params).then(res=>{
        this.platformData = res.data.data.records;
        let value = {appId:'international',name:'国际'}
        this.platformData.push(value)
      })
    }
  },
  created() {
    this.initPlatform();
  },
  mounted() {

  }
};
</script>
<style scoped>

</style>
